'use client'

import React, { useState, useEffect } from 'react'

const WhatsAppFloatingButton = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)

  const phoneNumber = '573028309637'
  const whatsappUrl = `https://wa.me/${phoneNumber}`
  const message = encodeURIComponent('¡Hola! 👋 Me interesa saber más sobre los vuelos en parapente con Airlovers Colombia. ¿Me pueden ayudar?')

  // Mostrar el botón después de 3 segundos de navegación
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true)
    }, 3000)

    // Mostrar tooltip después de 5 segundos
    const tooltipTimer = setTimeout(() => {
      setShowTooltip(true)
      // Ocultar tooltip después de 4 segundos
      setTimeout(() => setShowTooltip(false), 4000)
    }, 5000)

    return () => {
      clearTimeout(timer)
      clearTimeout(tooltipTimer)
    }
  }, [])

  const handleClick = () => {
    setShowTooltip(false)
  }

  return (
    <div className={`fixed bottom-6 right-6 z-50 transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
      {/* Contenedor principal */}
      <div className="relative">
        {/* Badge de "Respuesta Rápida" */}
        <div className="absolute -top-12 right-0 bg-white text-green-600 text-xs font-bold py-1 px-3 rounded-full shadow-lg whitespace-nowrap animate-bounce">
          ⚡ Respuesta rápida
        </div>

        {/* Botón principal de WhatsApp */}
        <a
          href={`${whatsappUrl}?text=${message}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleClick}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          className="group relative flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-green-400 via-green-500 to-green-600 shadow-2xl hover:shadow-green-500/50 transition-all duration-300 hover:scale-110"
          aria-label="Contactar por WhatsApp"
        >
          {/* Efecto de pulso múltiple */}
          <div className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-20"></div>
          <div className="absolute inset-0 rounded-full bg-green-400 animate-pulse opacity-30"></div>
          
          {/* Icono de WhatsApp */}
          <svg 
            className="w-9 h-9 text-white relative z-10" 
            fill="currentColor" 
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981z"/>
          </svg>

          {/* Tooltip */}
          <div className={`absolute right-full mr-4 top-1/2 transform -translate-y-1/2 transition-all duration-300 pointer-events-none ${showTooltip ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4'}`}>
            <div className="bg-gray-900 text-white text-sm font-medium py-2 px-4 rounded-lg whitespace-nowrap shadow-xl">
              <div className="flex items-center gap-2">
                <span className="text-green-400">💬</span>
                <span>¡Te respondemos en minutos!</span>
              </div>
              <div className="absolute top-1/2 right-0 transform translate-x-1/2 -translate-y-1/2 rotate-45 w-3 h-3 bg-gray-900"></div>
            </div>
          </div>
        </a>

        {/* Texto "Hablemos" en móvil */}
        <div className="md:hidden absolute right-full mr-3 top-1/2 transform -translate-y-1/2 bg-green-500 text-white text-xs font-bold py-1.5 px-3 rounded-full whitespace-nowrap shadow-lg">
          ¡Hablemos!
        </div>
      </div>
    </div>
  )
}

export default WhatsAppFloatingButton